const config = {
    product: 'Crimson AI',
    version: process.env.REACT_APP_VERSION || '2.0.0',
    rum_product_name: 'Crimson AI - Frontdoor',
    splunk_realm: 'us1'
};
  
export default config;
